<ng-container *ngIf="active">
  <ng-container *ngIf="isMobile">
    <app-swipe-up
      [height]="95"
      [showSwipeUp]="active"
      [showHeader]="true"
      (toggleShowSwipeUp)="onAccept()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="alertContent"></ng-container>
      </ng-container>
    </app-swipe-up>
  </ng-container>

  <ng-container *ngIf="!isMobile">
    <ng-container *ngIf="active">
      <app-modal [width]="640">
        <ng-container content>
          <ng-container *ngTemplateOutlet="alertContent"></ng-container>
        </ng-container>
      </app-modal>
    </ng-container>
  </ng-container>
</ng-container>


<ng-template #alertContent>
  <div class="bookingAlertModal__content">
    <span class="bookingAlertModal__icon">
      <i aria-hidden="true" class="icon-info"></i>
    </span>
    <p>{{alertText | transloco}}</p>
    <div class="bookingAlertModal__button">
      <app-ds-button
        [labels]="{ ButtonLabel: alertButtonText | transloco }"
        (clickEvent)="onAccept()">
      </app-ds-button>
    </div>
  </div>
</ng-template>